import React, { useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import TableLayout from "../../../../components/TableLayout";
import { CstmPagination } from "../../../../components/Common/Common";
import { useSharedLessonListQuery } from "store/services/lesson";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ShowAttachedFilesPop from "components/Modals/ViewAttachedFilesPop";
import TableHeader from "components/shared/FormComponents/TableHeader";
import ErrorComponent from "components/shared/ErrorComponent";

const SharedLessionPlan = () => {

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState({ search: "", status: "", sort: { column: "id", direction: "desc" } });
  const [files, setFiles] = useState([]);
  const [showAttachedFileModal, setShowAttachedFileModal] = useState(false);

  const { data, isLoading, isError, isFetching } = useSharedLessonListQuery({ page: currentPage, limit: pageSize, ...filter });
  const totalRecords = data?.totalRecords || 0;
  const totalPages = Math.ceil(totalRecords / pageSize);

  const resetFilter = () => {
    setFilter({ search: "", status: "", sort: { column: "id", direction: "desc" } });
    setCurrentPage(1)
  };

  const handleFilterChange = (key) => (value) => {
    setFilter((prevState) => ({
      ...prevState,
      [key]: value,
    }));
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    window.scrollTo(0, 0);
    setCurrentPage(page);
  };

  const column = [
    {
      head: "Lesson Name",
      accessor: "LessonName",
      isComponent: true,
      component: (item, ind) => (
        <div className="d-flex align-items-center gap-10">
          <h6 className="m-0 fw-sbold text-capitalize">{item?.sharedLessons?.title || "--"}</h6>
        </div>
      ),
    },
    {
      head: "Description",
      accessor: "Description",
      component: (item, ind) => (
        <>{item?.sharedLessons?.description || "--"}</>
      ),
    },
    {
      head: "Tags",
      accessor: "Tags",
      component: (item, ind) => (
        <div className="text-capitalize">
          {item?.sharedLessons?.tag || "--"}
        </div>
      ),
    },
    {
      head: "Attachment",
      accessor: "filename",
      component: (item, ind) => (
        <div>
          <Button className="d-flex align-items-center justify-center rounded-pill  fw-sbold border"
            style={{ fontFamily: "Merriweather", color: "#AEAEAE" }}
            variant="transparent"
            onClick={() => {
              if (item?.files?.length) {
                setFiles(item?.files || []);
                item?.files?.length && setShowAttachedFileModal(true);
              }
            }}
          >
            {item?.files?.length || 0} Files
            <span className="icn ms-1">{Icon}</span>
          </Button>
        </div>
      ),
    },
    {
      head: " Shared User Email",
      accessor: "SharedUserEmail",
      component: (item, ind) => (
        <div>
          {item?.sharedLessons?.sharedLessonBy?.email || "--"}
        </div>
      ),
    },
  ];

  return (
    <>
      <ShowAttachedFilesPop
        show={showAttachedFileModal}
        setShow={setShowAttachedFileModal}
        files={files}
      />
      <section className="designations position-relative py-4">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                <div className="left">
                  <TableHeader
                    heading={"Shared Lesson Plan"}
                    handleFilterChange={handleFilterChange}
                    filter={filter}
                    resetFilter={resetFilter}
                    searchPlaceholder="Lesson Name"
                  />
                </div>
                <div className="right"></div>
              </div>
              <div className="table-outer">
                {isLoading ? (
                  <div style={{ height: "200px" }}>
                    <LoadingIndicator />
                  </div>
                ) : isError ? (
                  <ErrorComponent />
                ) : (
                  <>
                    {(isFetching) && <LoadingOverlay />}
                    <TableLayout
                      data={data?.records || []}
                      column={column}
                      handleSort={handleFilterChange("sort")}
                      filter={filter}
                    />
                  </>
                )}
                <CstmPagination
                  totalPages={totalPages}
                  activePage={currentPage}
                  handlePageChange={handlePageChange}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};
export default SharedLessionPlan;

const Icon = <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.5">
    <mask id="mask0_5385_24336" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_5385_24336)">
      <path d="M3.75 8.99991C3.75 10.1624 4.07812 11.203 4.73438 12.1218C5.39062 13.0405 6.25625 13.6687 7.33125 14.0062C7.55625 14.0812 7.74062 14.2218 7.88437 14.428C8.02812 14.6343 8.1 14.8624 8.1 15.1124C8.1 15.4749 7.94688 15.7624 7.64062 15.9749C7.33437 16.1874 7 16.2312 6.6375 16.1062C5.0875 15.5937 3.84375 14.6874 2.90625 13.3874C1.96875 12.0874 1.5 10.6249 1.5 8.99991C1.5 7.37491 1.96875 5.91241 2.90625 4.61241C3.84375 3.31241 5.0875 2.40616 6.6375 1.89366C7 1.76866 7.33437 1.81241 7.64062 2.02491C7.94688 2.23741 8.1 2.52491 8.1 2.88741C8.1 3.13741 8.02812 3.36554 7.88437 3.57179C7.74062 3.77804 7.55625 3.91866 7.33125 3.99366C6.25625 4.33116 5.39062 4.95929 4.73438 5.87804C4.07812 6.79679 3.75 7.83741 3.75 8.99991ZM14.2875 14.2874C13.8875 14.6999 13.4344 15.0593 12.9281 15.3655C12.4219 15.6718 11.8938 15.9187 11.3438 16.1062C10.9812 16.2312 10.6469 16.1874 10.3406 15.9749C10.0344 15.7624 9.88125 15.4749 9.88125 15.1124C9.88125 14.8624 9.95312 14.6343 10.0969 14.428C10.2406 14.2218 10.425 14.0812 10.65 14.0062C11.0375 13.8812 11.4094 13.7093 11.7656 13.4905C12.1219 13.2718 12.4438 13.0187 12.7313 12.7312C13.0188 12.4312 13.2688 12.1093 13.4813 11.7655C13.6938 11.4218 13.8688 11.0499 14.0063 10.6499C14.0813 10.4249 14.2219 10.2405 14.4281 10.0968C14.6344 9.95304 14.8625 9.88116 15.1125 9.88116C15.475 9.88116 15.7625 10.0343 15.975 10.3405C16.1875 10.6468 16.2313 10.9812 16.1063 11.3437C15.9188 11.8937 15.6719 12.4187 15.3656 12.9187C15.0594 13.4187 14.7 13.8749 14.2875 14.2874ZM14.2875 3.71241C14.7 4.12491 15.0594 4.58116 15.3656 5.08116C15.6719 5.58116 15.9188 6.10616 16.1063 6.65616C16.2313 7.01866 16.1875 7.35304 15.975 7.65929C15.7625 7.96554 15.475 8.11866 15.1125 8.11866C14.8625 8.11866 14.6344 8.04679 14.4281 7.90304C14.2219 7.75929 14.0813 7.57491 14.0063 7.34991C13.8688 6.94991 13.6938 6.57804 13.4813 6.23429C13.2688 5.89054 13.0188 5.56866 12.7313 5.26866C12.4438 4.98116 12.1219 4.72804 11.7656 4.50929C11.4094 4.29054 11.0375 4.11866 10.65 3.99366C10.425 3.91866 10.2406 3.77804 10.0969 3.57179C9.95312 3.36554 9.88125 3.13741 9.88125 2.88741C9.88125 2.52491 10.0344 2.23741 10.3406 2.02491C10.6469 1.81241 10.9812 1.76866 11.3438 1.89366C11.8938 2.08116 12.4219 2.32804 12.9281 2.63429C13.4344 2.94054 13.8875 3.29991 14.2875 3.71241Z" fill="#071E3E" />
      <mask id="mask1_5385_24336" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="3" y="3" width="12" height="12">
        <rect x="3.75" y="3.75" width="10.604" height="10.604" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask1_5385_24336)">
        <path d="M9.05164 6.84351C8.80863 6.84351 8.6006 6.75698 8.42755 6.58393C8.25449 6.41088 8.16797 6.20285 8.16797 5.95984C8.16797 5.71683 8.25449 5.5088 8.42755 5.33575C8.6006 5.1627 8.80863 5.07617 9.05164 5.07617C9.29464 5.07617 9.50267 5.1627 9.67573 5.33575C9.84878 5.5088 9.9353 5.71683 9.9353 5.95984C9.9353 6.20285 9.84878 6.41088 9.67573 6.58393C9.50267 6.75698 9.29464 6.84351 9.05164 6.84351ZM9.05164 13.0292C8.86754 13.0292 8.71106 12.9647 8.58219 12.8359C8.45332 12.707 8.38889 12.5505 8.38889 12.3664V8.38992C8.38889 8.20583 8.45332 8.04934 8.58219 7.92048C8.71106 7.79161 8.86754 7.72717 9.05164 7.72717C9.23573 7.72717 9.39222 7.79161 9.52108 7.92048C9.64995 8.04934 9.71439 8.20583 9.71439 8.38992V12.3664C9.71439 12.5505 9.64995 12.707 9.52108 12.8359C9.39222 12.9647 9.23573 13.0292 9.05164 13.0292Z" fill="#071E3E" />
      </g>
    </g>
  </g>
</svg>